import types from '@/vuex/reencaminhamento-documento/mutations-types'

const mutations = {
  [types.SET_PASSO_ATUAL]: (state, payload) => {
    state.passoAtual = payload.passoAtual
  },
  [types.SET_LISTA_UNIDADES]: (state, payload) => {
    state.listaUnidades = payload.listaUnidades
  },
  [types.SET_UNIDADE]: (state, payload) => {
    state.unidadeSelecionada = payload.unidadeSelecionada
  },
  [types.SET_LISTA_DOCUMENTOS]: (state, payload) => {
    state.listaDocumentos = payload.listaDocumentos
  },
  [types.SET_DOCUMENTO]: (state, payload) => {
    state.documentoSelecionado = payload.documentoSelecionado
  },
  [types.SET_NUMERO_DOCUMENTO]: (state, payload) => {
    state.numeroDocumento = payload.numeroDocumento
  }
}
export default mutations
